export default {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderRadius: 0,
    border: "1px solid #565c65",
    color: "#1b1b1b",
    marginTop: ".5rem",
    maxWidth: "30rem",
    padding: ".5rem",
    width: "100%",
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    maxWidth: "30rem",
    width: "100%",
  }),
};
